import { render, staticRenderFns } from "./CommentVideoAlert.vue?vue&type=template&id=dadaadc6&scoped=true&"
import script from "./CommentVideoAlert.vue?vue&type=script&lang=js&"
export * from "./CommentVideoAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommentVideoAlert.vue?vue&type=style&index=0&id=dadaadc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadaadc6",
  null
  
)

export default component.exports